import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './ManagePreferencesTabHeader.module.scss';

const cx = classNames.bind(styles);

const ManagePreferencesTabHeader = (): ReactElement => {
  return (
    <div className={cx('body')} data-testid="manage-preferences-tab-header">
      <h1 className={cx('title')}>Preferences</h1>
      <p className={cx('subtitle')}>
        Add your coverage interests from different categories to view a personalized feed and email alerts.
      </p>
    </div>
  );
};

export default ManagePreferencesTabHeader;
